export default "__VITE_ASSET__8a36d844__"